import React, { Component } from "react";
import {
  getAppliedBooster,
  getBoosterClass,
  getBoostersObject,
  getTrans,
  makeManageTeamSkeleton,
  updateBusters,
} from "../../common";
import config from "../../common/config";
import {
  BoosterCardContext,
  CompositionContext,
  FixturesContext,
  GamedaysContext,
  PlayerListContext,
  TeamDataContext,
  TransContext,
} from "../../Context";
import { Consume } from "../../Context/Consumer";
class BoosterButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFreeze: false,
    };
  }

  componentDidMount() {
    const { childRef } = this.props;
    childRef && childRef(this);
  }

  removeBooster = (booster) => {
    let self = this;
    self.setState({
      isFreeze: true,
    });
    let { props } = self;
    if (config.enumBoosterTypes.two.indexOf(booster.BoosterId + "") > -1) {
      let selectedTeamT = { ...props.Gamedays.selectedTeam };
      selectedTeamT.Boosters.forEach((obj, ind) => {
        if (obj.Id === booster.BoosterId) {
          selectedTeamT.Boosters[ind].IsTaken = 0;
          selectedTeamT.Boosters[ind].GdId = null;
        }
      });
      self.props.setInitialData && self.props.setInitialData();
      props.Gamedays.setSelectedTeam(selectedTeamT);
      props.BoosterCardData.setTempLimitlessBooster(false);
      let msg = getTrans(
        this.props.TransData.data,
        "booster_removed_successfully",
        "Booster Removed Successfully"
      );
      this.props.showHideToast(true, msg, false, false, true);
      self.setState({
        isFreeze: false,
      });
    } else {
      let apiParams = {
        platform: config.platformId,
        gamedayId: props.FixturesData.currMatchDay.GamedayId,
        phaseId: props.FixturesData.currMatchDay.PhaseId,
        boosterId: booster.BoosterId,
      };

      props.BoosterCardData.removeBooster(
        apiParams,
        (resp) => {
          let msg = getTrans(
            this.props.TransData.data,
            "booster_removed_successfully",
            "Booster Removed Successfully"
          );
          this.props.showHideToast(true, msg, false, false, true);
          updateBusters("/team");
          let params = {
            optType: config.optType,
            gamedayId: props.FixturesData.currMatchDay.GamedayId,
            phaseId: props.FixturesData.currMatchDay.PhaseId,
            language: config.language,
          };
          props.Gamedays.getSelectedTeam(
            params,
            (response) => {
              let teamDataSkeleton = makeManageTeamSkeleton(
                response?.Data?.Value,
                self.props.PlayerListData.rawPlayerList,
                self.props.CompositionData.data
              );
              self.props.TeamData.setTeamData(teamDataSkeleton.teamData);
              props.FixturesData.setGameMode(config.modes.transfer);
              self.setState({
                isFreeze: false,
              });
            },
            () => {}
          );
        },
        (err) => {
          let retVal = err.RetVal;
          let msg = "RetVal = " + retVal;
          this.props.showHideToast(true, msg, true);
          self.setState({
            isFreeze: false,
          });
        }
      );
    }
  };
  render() {
    let self = this;
    let boosterBtn = null;
    let {
      showHideBoosterPopup,
      currMatchDay,
      mode,
      TransData,
      isManageScreen,
      TeamData,
      BoosterCardData,
      isTransferSummaryScreen,
    } = self.props;
    let transData = TransData.data;
    let teamData = TeamData.data;
    let boosterBtnText = (
      <span>
        <i className="uae-booster"></i>{" "}
        {getTrans(transData, "play_booster_btn", "Play Booster")}
      </span>
    );

    let boosters = getBoostersObject(
      this.props.CompositionData.boostersList,
      this.props.Gamedays?.selectedTeam?.Boosters
    );
    let sDisabled =
      teamData.IsWildCardTaken === 1 &&
      teamData.UserWildCardGameday === currMatchDay.GamedayId
        ? "si-disabled"
        : "";
    let boosterApplied = getAppliedBooster(boosters, currMatchDay.GamedayId);
    boosterBtn =
      mode === config.modes.transfer ? (
        <div
          className={
            "si-btn si-btn__white si-btn__white--outline " +
            (config.isMobile ? " " : "si-hide--mob ") +
            sDisabled
          }
          onClick={() => showHideBoosterPopup(true)}
        >
          {boosterBtnText}
        </div>
      ) : null;
    if (
      boosterApplied?.IsTaken ||
      BoosterCardData.isTempLimitlessBooster ||
      (teamData.IsWildCardTaken === 1 &&
        teamData.UserWildCardGameday === currMatchDay.GamedayId)
    ) {
      boosterBtnText = (
        <>
          <img
            src={`${config.IMG_BASE}boosters/${boosterApplied?.BoosterId}.svg?v=${config.WebConfig.imgVersion}`}
            alt={getTrans(
              transData,
              config.WebConfig.BoosterRules[boosterApplied?.BoosterId]?.name
            )}
            title={getTrans(
              transData,
              config.WebConfig.BoosterRules[boosterApplied?.BoosterId]?.name
            )}
          />
          <span>
            {getTrans(
              transData,
              config.WebConfig.BoosterRules[boosterApplied?.BoosterId]?.name
            )}{" "}
            {mode === config.modes.viewpoint
              ? getTrans(transData, "played", "Played")
              : getTrans(transData, "active", "Active")}
          </span>
          {mode === config.modes.transfer &&
            (config.enumBoosterTypes.two.indexOf(
              boosterApplied?.BoosterId + ""
            ) > -1
              ? BoosterCardData.isTempLimitlessBooster
              : true) &&
            (isTransferSummaryScreen ? null : (
              <i
                className="uae-close"
                onClick={() =>
                  !self.state.isFreeze && self.removeBooster(boosterApplied)
                }
              ></i>
            ))}
        </>
      );
      let boosterClass =
        boosterApplied?.BoosterId && getBoosterClass(boosterApplied);
      if (
        teamData.IsWildCardTaken === 1 &&
        teamData.UserWildCardGameday === currMatchDay.GamedayId
      ) {
        boosterClass = "si-wiCa";
        boosterBtnText = (
          <span>
            {
              /* getTrans(
              transData,
              config.WebConfig.BoosterRules[boosterApplied?.BoosterId]?.name
            ) */
              "Wildcard"
            }{" "}
            {mode === config.modes.viewpoint
              ? getTrans(transData, "played", "Played")
              : getTrans(transData, "active", "Active")}
          </span>
        );
      }
      boosterBtn = (
        <div
          className={`si-btn si-btn__booster ${
            config.isMobile ? "" : "si-hide--mob"
          } ${boosterClass} ${
            (boosterApplied?.IsTaken && mode === config.modes.live) ||
            mode === config.modes.substitution ||
            mode === config.modes.viewpoint
              ? "si-disabled"
              : ""
          }        
          `}
        >
          {boosterBtnText}
        </div>
      );
    }
    return <> {boosterBtn}</>;
  }
}
export default Consume(BoosterButton, [
  CompositionContext,
  GamedaysContext,
  BoosterCardContext,
  TransContext,
  FixturesContext,
  PlayerListContext,
  TeamDataContext,
]);
